import { IconTypes } from "../Icons";

export default function WebSliders({ color = '#ffffff', fontSize = '1.6rem', rotate = 0, className = '' }: IconTypes) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      style={{ width: '1em', height: '1em', fontSize, transform: `rotate(${rotate}deg)` }}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask id="mask0_1116_13106" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
        <path d="M0 1.90735e-06H20V20H0V1.90735e-06Z" fill="white" />
      </mask>
      <g mask="url(#mask0_1116_13106)">
        <path d="M17.899 18.2422H2.10108C1.26432 18.2422 0.585999 17.5638 0.585999 16.727V3.2729C0.585999 2.4361 1.26432 1.75778 2.10108 1.75778H17.899C18.7358 1.75778 19.4141 2.4361 19.4141 3.2729V16.727C19.4141 17.5638 18.7358 18.2422 17.899 18.2422Z" stroke="#99A5AD" stroke-width="1.17187" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M0.585938 6.05469H19.4141" stroke="#99A5AD" stroke-width="1.17187" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M17.6562 3.90625C17.6562 4.22984 17.3939 4.49219 17.0703 4.49219C16.7467 4.49219 16.4844 4.22984 16.4844 3.90625C16.4844 3.58266 16.7467 3.32031 17.0703 3.32031C17.3939 3.32031 17.6562 3.58266 17.6562 3.90625Z" fill="#99A5AD" />
        <path d="M15.3125 3.90625C15.3125 4.22984 15.0502 4.49219 14.7266 4.49219C14.403 4.49219 14.1406 4.22984 14.1406 3.90625C14.1406 3.58266 14.403 3.32031 14.7266 3.32031C15.0502 3.32031 15.3125 3.58266 15.3125 3.90625Z" fill="#99A5AD" />
        <path d="M12.3711 12.1485C12.3711 13.458 11.3095 14.5196 9.99996 14.5196C8.69047 14.5196 7.62891 13.458 7.62891 12.1485C7.62891 10.839 8.69047 9.77737 9.99996 9.77737C11.3095 9.77737 12.3711 10.839 12.3711 12.1485Z" stroke="#99A5AD" stroke-width="1.17187" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M7.62891 12.1484H2.92969" stroke="#99A5AD" stroke-width="1.17187" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M12.3711 12.1484H17.0703" stroke="#99A5AD" stroke-width="1.17187" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
      </g>
    </svg>

  )
}
